import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M20 19V14.92H22V19C22 20.1 21.1 21 20 21H4C2.9 21 2 20.1 2 19V14.99H4V19H20ZM5.75 9.24L7.17 10.66L10.99 6.85V15.96H13V6.85L16.82 10.66L18.24 9.24L12 3L5.75 9.24Z" fill={ fill || 'currentColor' } />
    </svg>
);
